<template>
  <div class="promotion-page-container">
    <svg-icon :name="promotionPageData.icon" :style="{ fontSize: '70px' }" />
    <div class="emptyText" v-if="!promotionPageData.noShowEmptyText">
      <p :style="{ width: promotionPageData.emptyTextWidth + 'px' }">
        {{ promotionPageData.emptyText }}
      </p>
    </div>
    <div class="mainDescribe" v-if="promotionPageData.showMainDescribe">
      <p :style="{ width: promotionPageData.mainDescribeWidth + 'px' }">
        {{ promotionPageData.mainDescribe }}
      </p>
    </div>
    <div class="btn-container">
      <div class="selfAddBtn" v-if="promotionPageData.btnType === 'dropdown'">
        <el-dropdown
          slot="self"
          trigger="click"
          @command="
            (command) => {
              onDropdownCommand(command);
            }
          "
        >
          <common-button type="primary">{{
            promotionPageData.dropdownBtnText
          }}</common-button>
          <el-dropdown-menu
            slot="dropdown"
            class="top-btn-dropdown-menu-container"
          >
            <el-dropdown-item
              :command="item.command"
              v-for="(item, index) in promotionPageData.dropdownList"
              :key="index + Date.now()"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <el-tooltip
        class="item"
        effect="dark"
        content="No Permission"
        placement="top"
        :disabled="!promotionPageData.noPermission"
      >
        <span>
          <common-button
            size="small"
            type="primary"
            @click="mainBtnclick()"
            :loading="mainBtnLoading"
            v-if="promotionPageData.showbtn"
            :disabled="promotionPageData.disabled"
            >{{ promotionPageData.btnText }}</common-button
          >
        </span>
      </el-tooltip>

      <div
        class="sub-btn"
        @click="subBtnclick()"
        v-if="promotionPageData.showbtn2"
      >
        <svg-icon
          v-if="promotionPageData.showSubBtnIcon"
          :name="promotionPageData.subBtnIcon"
          :style="{
            fontSize: '16px',
            color: '#4066d4',
            marginRight: '4px',
          }"
        />
        <span>{{ promotionPageData.btnText2 }}</span>
        <svg-icon
          v-if="promotionPageData.showSubBtnIcon2"
          :name="promotionPageData.subBtnIcon"
          :style="{
            fontSize: '16px',
            marginLeft: '8px',
          }"
        />
      </div>
      <div class="des-btn">{{ promotionPageData.btnTextDes }}</div>
    </div>
    <div
      class="content-container"
      v-if="promotionPageData.showContentContainer"
    >
      <div class="content">
        <div
          class="item"
          :style="{ width: item.itemWidth + 'px' }"
          v-for="(item, index) in promotionPageData.contentList"
          :key="index + Date.now()"
        >
          <svg-icon
            :name="item.icon"
            :style="{ fontSize: '60px' }"
            v-if="item.icon"
          />
          <img :src="item.src" alt="" v-else />
          <div class="title">{{ item.title }}</div>
          <div class="describe">{{ item.describe }}</div>
        </div>
      </div>
      <div class="footer" v-if="type === 'driver'">
        <img src="../../../images/driver-membership-tags.png" alt="" />
        <span>
          Each driver added from Command will get a Premium Membership of
          Trucker Path.
          <a
            href="https://truckerpath.com/trucker-path-app/"
            class="learn-more"
            target="_blank"
          >
            Learn More</a
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import {
  loadData,
  driverData,
  assetTruckData,
  assetTrailerData,
  documentData,
  contactsData,
  invoiceData,
} from "./config";
export default {
  props: {
    type: {
      type: String,
      default: "",
    },
    mainBtnLoading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [],
  components: {},
  data() {
    return {
      promotionPageData: {},
    };
  },
  computed: {
    ...mapState({
      addDriver: (state) => state.user.addDriver,
      connectEld: (state) => state.user.connectEld,
      topHeight: (state) => state.user.topHeight,
    }),
    ...mapGetters("user", ["usersAuthorities", "systemSource"]),
  },
  watch: {
    // 监听connectEld
    connectEld: {
      handler(value) {
        if (this.type === "assetTruck") {
          this.assetTruckChange(value);
        }
      },
      immediate: true,
      deep: true,
    },
    // 监听addDriver
    addDriver: {
      handler(value) {
        if (this.type === "document") {
          console.log(value,'value-11')
          this.documentChange(value);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    switch (this.type) {
      case "load":
        loadData.disabled = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        loadData.noPermission = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        this.promotionPageData = loadData;
        break;
      case "driver":
        driverData.disabled =
          this.usersAuthorities["fleet:accountOperation:driverCreate"] ===
          "false" || (this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false');
        driverData.noPermission =
          this.usersAuthorities["fleet:accountOperation:driverCreate"] ===
          "false" || (this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false');
        this.promotionPageData = driverData;
        break;
      case "assetTruck":
        assetTruckData.disabled = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        assetTruckData.noPermission = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        this.promotionPageData = assetTruckData;
        this.assetTruckChange(this.connectEld);
        break;
      case "assetTrailer":
        assetTrailerData.disabled = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        assetTrailerData.noPermission = this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false';
        this.promotionPageData = assetTrailerData;
        break;
      case "document":
        this.promotionPageData = documentData;
        this.documentChange(this.addDriver);
        console.log(this.addDriver,'value-222')
        break;
      case "contacts":
        this.promotionPageData = contactsData;
        break;
      case "invoice":
        this.promotionPageData = invoiceData;
        break;
    }
  },
  mounted() {
    let promotionPageContainer = document.querySelector(
      ".promotion-page-container"
    );
    let heightF = 184 + this.topHeight;
    promotionPageContainer.style.height = `calc(100vh - ${57+heightF + "px"})`;
    this.$nextTick(()=> {
      let vxeTableHeaderHeight = document.querySelector(
        ".vxe-table--header-wrapper"
      ).clientHeight;
      console.log('vxeTableHeaderHeight',vxeTableHeaderHeight);
      promotionPageContainer.style.top = vxeTableHeaderHeight + "px";
    })
  },
  methods: {
    mainBtnclick() {
      if (this.promotionPageData.btnTextJumpRouter) {
        this.$router.push({
          path: this.promotionPageData.btnTextGoRouter,
        });
      } else {
        this.$emit("mainBtnclick", this.promotionPageData);
      }
    },
    documentChange(flag) {
      console.log(flag,'flag---rw')
      if (flag) {
        this.promotionPageData.btnText = "Upload Documents";
        this.promotionPageData.btnText2 =
          "Watch a video to learn how to collect documents from drivers";
        this.promotionPageData.emptyText =
          "Upload documents from your computer or you can receive them from your drivers";
        this.promotionPageData.showbtn2 = true;
        this.promotionPageData.icon = "doc-empty-state2";
        this.promotionPageData.showMainDescribe = false;
        this.promotionPageData.emptyTextWidth = 350;
      } else {
        this.promotionPageData.disabled =
          this.usersAuthorities["fleet:accountOperation:driverCreate"] ===
          "false" || (this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false');
        this.promotionPageData.noPermission =
          this.usersAuthorities["fleet:accountOperation:driverCreate"] ===
          "false" || (this.systemSource === 'dispatcher' && this.usersAuthorities['fleet:carrierBusiness:editSelfEntity'] === 'false');
        this.promotionPageData.showbtn2 = false;
        this.promotionPageData.showMainDescribe = true;
        this.promotionPageData.btnText = "Add New Drivers";
        this.promotionPageData.emptyText = "Add drivers to collect documents";
        this.promotionPageData.icon = "doc-empty-state";
        this.promotionPageData.emptyTextWidth = 400;
      }
    },
    assetTruckChange(flag) {
      if (flag) {
        this.promotionPageData.emptyText =
          "ELD connected. Import trucks to see real-time locations";
        this.promotionPageData.btnText = "Import Trucks from ELD";
        this.promotionPageData.showbtn = false;
        this.promotionPageData.btnTextGoRouter = "";
        this.promotionPageData.btnText2GoRouter =
          "/assets/create/truck?type=add&typeFrom=Truck";
        this.promotionPageData.btnTextJumpRouter = false;
        this.promotionPageData.showbtn2 = false;
        this.promotionPageData.emptyTextWidth = 300;
      } else {
        this.promotionPageData.emptyText = "Add new trucks to get started";
        this.promotionPageData.btnText = "Add New Trucks";
        this.promotionPageData.btnText2 =
          "Connect your ELD to access and use its information via Command";
        this.promotionPageData.btnTextGoRouter =
          "/assets/create/truck?type=add&typeFrom=Truck";
        this.promotionPageData.btnText2GoRouter = "/setting/eld";
        this.promotionPageData.btnTextJumpRouter = true;
        this.promotionPageData.showbtn2 = true;
        this.promotionPageData.emptyTextWidth = 400;
      }
    },
    subBtnclick() {
      if (this.promotionPageData.btnText2JumpRouter) {
        this.$router.push({
          path: this.promotionPageData.btnText2GoRouter,
        });
      } else {
        this.$emit("subBtnclick", this.promotionPageData);
      }
    },
    onDropdownCommand(item) {
      this.$emit("promotionPpageOnDropdownCommand", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.promotion-page-container {
  background: #ffffff;
  position: absolute;
  z-index: 999;
  top: 40px;
  width: calc(100vw - 72px);
  text-align: center;
  padding: 38px 24px 24px;
  min-width: 1368px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    width: 8px;
  }
  .emptyText {
    display: flex;
    justify-content: center;
    margin-top: 6px;
    p {
      width: 300px;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      font-weight: bold;
      color: #000;
    }
  }
  .mainDescribe {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    p {
      font-weight: 500;
      font-size: 12px;
      font-weight: 500;
      color: #7f8596;
      width: 300px;
    }
  }
  .btn-container {
    display: inline-block;
    margin-top: 13px;
    /deep/ .common-button--small{
          font-size:14px;
          font-weight: 700;
          padding: 0 16px;
    }
    .tp-add-btn {
      background: url("~@/assets/img/tp-header/add.svg") no-repeat;
      background-position: 18px center;
      background-size: 16px 16px;
      background-color: #4066d4;
      color: #fff;
      padding: 9px 18px 9px 40px;
      font-size: 14px;
      line-height: 22px;
      border-radius: 2px;
      font-weight: 500;
      font-stretch: normal;
      cursor: pointer;
      font-weight: bold !important;

      &:hover {
        background-color: #0076ff;
      }
    }
    .sub-btn {
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 16px;
      span {
        font-weight: 600;
        font-size: 14px;
        font-weight: 600;
        color: #4066d4;
      }
    }
  }
  .content-container {
    .content {
      margin-top: 42px;
      display: flex;
      justify-content: center;
      .item {
        width: 220px;
        text-align: center;
        margin-right: 40px;
        display: inline-block;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 60px;
          height: 60px;
        }
        .title {
          font-weight: bold;
          font-size: 12px;
          font-weight: bold;
          color: #000;
          margin-top: 12px;
        }
        .describe {
          font-weight: 500;
          font-size: 12px;
          font-weight: 500;
          color: #7f8596;
          margin-top: 8px;
        }
      }
    }
    .footer {
      margin-top: 18px;
      border-top: 1px solid #dadce1;
      padding-top: 12px;
      .price {
        color: #000;
      }
      > span {
        vertical-align: middle;
        font-size: 12px;
        font-weight: 500;
        color: #7f8596;
        font-weight: 500;
      }
      .learn-more {
        font-weight: 600;
        font-weight: 600;
        color: #4066d4;
        margin-left: 16px;
        text-decoration: none;
      }
      img {
        width: 69px;
        height: 24px;
        vertical-align: middle;
        margin-right: 12px;
      }
    }
  }
}
.top-btn-dropdown-menu-container {
  width: 151px;
  margin-top: 6px !important;
  margin-left: -6px;
  padding: 8px 0;
  .el-dropdown-menu__item {
    // text-align: center;
    font-weight: 500;
    font-size: 12px;
    font-weight: 500;
    color: #000000;
    padding: 8px 12px;
    line-height: normal;
    &:hover {
      background: #f6f7f9;
      color: #000000;
    }
  }
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
  ::v-deep {
    .popper__arrow {
      display: none;
    }
  }
}
</style>
